import React from 'react';
import PropTypes from 'prop-types';
import css from './KioskImage.css';

const KioskImage = ({imageUrl, size}) => {
  const getImgHwTw = (imgSize) => {
    switch (imgSize) {
      case 'L':
        return 128;
      case 'M':
      default:
        return 64;
      case 'S':
        return 32;
    }
  };

  const imgHtWt = getImgHwTw(size);
  return (
    <div
      className={css['image']}
      style={ {backgroundImage: `url(${imageUrl})`,  height: imgHtWt, minWidth: imgHtWt}}
      role="img"
      aria-hidden={true}
    />
  );
};

KioskImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  size: PropTypes.string
};

export default KioskImage;
